import { Controller, useFormContext } from 'react-hook-form';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';

import { Select } from '@c/select';

import { UserFilterForm } from '@t/user/components/filter/field-values.schema';

const UserFilterBody = () => {
  const { control } = useFormContext<UserFilterForm>();

  return (
    <FormGroup row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>First Name</Label>
        </Col>
        <Col>
          <Controller
            control={control}
            name="firstName"
            render={({ field: { onChange, value } }) => (
              <Input
                onChange={() => onChange}
                type="text"
                value={value}
              />
            )}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>Last Name</Label>
        </Col>
        <Col>
          <Controller
            control={control}
            name="lastName"
            render={({ field: { onChange, value } }) => (
              <Input
                onChange={() => onChange}
                type="text"
                value={value}
              />
            )}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>Department</Label>
        </Col>
        <Col>
          <Controller
            control={control}
            name="department"
            render={({ field: { onChange, value } }) => (
              <Select
                onChange={() => onChange}
                placeholder="Select Department"
                value={value}
              />
            )}
          />
        </Col>
      </Row>
      <Row className="mb-3">
        <Col sm={3}>
          <Label>Role</Label>
        </Col>
        <Col>
          <Controller
            control={control}
            name="role"
            render={({ field: { onChange, value } }) => (
              <Select
                onChange={() => onChange}
                placeholder="Select Role"
                value={value}
              />
            )}
          />
        </Col>
      </Row>
    </FormGroup>
  );
};

export default UserFilterBody;
